import * as React from 'react'

import { Modal } from 'main/ui'
import Content from './Content'

interface IProps {
  schoolId: number
  onRequestClose: () => void
}

export default function DetailedPricingModal(props: IProps) {
  const { schoolId, onRequestClose } = props

  return (
    <Modal title="Pricing" kind="large" onRequestClose={onRequestClose}>
      <Content schoolId={schoolId} />
    </Modal>
  )
}
